import React from "react"
import { Box, Flex } from "@chakra-ui/core"
import { Button } from "../Buttons"
import LinkButton from "../LinkButton"
import Body from "../typography/Body"
import { bp } from "../../utils/MediaQueries"

type CookieBannerProps = {
  onAccept: () => void
  onOptOut: () => void
  onManage: () => void
}

export default function CookieBanner({
  onAccept,
  onOptOut,
  onManage,
}: CookieBannerProps) {
  return (
    <Box
      role="region"
      aria-label="Cookie notice"
      position="fixed"
      left={0}
      right={0}
      bottom={0}
      zIndex={999999}
      bg="white"
      borderTop="1px solid"
      borderColor="dividerLine"
      boxShadow="big"
      px={bp("1rem", "2.5rem")}
      py={bp("1rem", "1.25rem")}
    >
      <Flex
        maxW="80rem"
        mx="auto"
        direction={bp("column", "row")}
        align={bp("stretch", "center")}
        justify="space-between"
      >
        <Body
          size="sm"
          color="dusk"
          mr={bp(0, "2rem")}
          mb={bp("0.75rem", 0)}
        >
          We use cookies to improve your experience and show relevant offers.{" "}
          <LinkButton fontSize="inherit" onClick={onManage}>
            Cookie settings
          </LinkButton>
        </Body>
        <Flex flexShrink={0}>
          <Button
            theme="secondary"
            h="2.5rem"
            px="1.5rem"
            mr="0.75rem"
            flex={bp(1, "none")}
            onClick={onOptOut}
          >
            Reject all
          </Button>
          <Button
            theme="primary"
            h="2.5rem"
            px="1.5rem"
            flex={bp(1, "none")}
            onClick={onAccept}
          >
            Accept all
          </Button>
        </Flex>
      </Flex>
    </Box>
  )
}
